import { render, staticRenderFns } from "./LandingFullWidthVideo.vue?vue&type=template&id=2d954bb7&scoped=true"
import script from "./LandingFullWidthVideo.vue?vue&type=script&lang=js"
export * from "./LandingFullWidthVideo.vue?vue&type=script&lang=js"
import style0 from "./LandingFullWidthVideo.vue?vue&type=style&index=0&id=2d954bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d954bb7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingPageCard: require('/src/components/landing/LandingPageCard.vue').default})
